import React, {useContext, useState} from 'react'
import Filter from "../../../statics/assets/icons/filter.svg"
import {SettingTenantDealerContext} from "../context/SettingTenantDealerContext"
import TenantFilter from "./filters/TenantFilter"
import TenantTable from "./data-table/TenantTable"
import {Pagination} from "antd"
import AddTenantParam from "./actions/AddTenantParam"
import _checkRoles from "../../../helpers/checkRole"

function SettingTenantDealerPage(props) {
    const SettingTenantPageContext = useContext(SettingTenantDealerContext)

    const {
        loading,
        error,
        filters,
        pagination,
        total,
        listTenantDealer,
        setPagination,
        onChangeFilter
    } = SettingTenantPageContext

    const [showFilters, toggleFilters] = useState(false)

    const _toggleShowFilter = () => {
        toggleFilters(!showFilters)
    }

    const _onChangePagination = (page, pageSize) => {
        setPagination({
            page: pageSize !== pagination.size ? 1 : page,
            size: pageSize
        })
    }

    return (
        <div className='LeadPage PageDefault position-relative'>
            <div className="PageHeading">
                <h1 className="PageTitle">Quản lý tenant đại lý</h1>
                <div className="d-flex align-items-center">
                    <div className={`Filter mr-3 ${showFilters && 'filtersOpen'}`}>
                        <label onClick={_toggleShowFilter}><Filter width={20} height={20}/>Bộ lọc</label>
                    </div>

                    {
                        _checkRoles('menu.setting.tenantDealer.addTenant') &&
                        <AddTenantParam/>
                    }
                </div>
            </div>

            {
                showFilters && <TenantFilter filters={filters} onChangeFilter={onChangeFilter}/>
            }

            <div className="PagePagination d-flex justify-content-end align-items-center mb-3">
                <div className="total mr-3">Total {total} items</div>
                <Pagination
                    className="PaginationCustom"
                    pageSizeOptions={['20', '50', '100', '200']}
                    total={total}
                    pageSize={pagination.size}
                    current={pagination.page}
                    onChange={_onChangePagination}
                />
            </div>

            <div className="PageTable pb-0">
                <TenantTable
                    loading={loading}
                    error={error}
                    listTenantDealer={listTenantDealer}
                />
            </div>

            <div className="PagePagination d-flex justify-content-end align-items-center mt-3">
                <div className="total mr-3">Total {total} items</div>
                <Pagination
                    className="PaginationCustom"
                    pageSizeOptions={['20', '50', '100', '200']}
                    total={total}
                    pageSize={pagination.size}
                    current={pagination.page}
                    onChange={_onChangePagination}
                />
            </div>
        </div>
    )
}

export default SettingTenantDealerPage